import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { DocumentService, LoaderService, PortalService, RoutingService, SecurityService, UserService } from 'src/app/services';
import { DocumentType, IdentityUserAccount, IESignInputModel, IESignResponse, IPortalConfig, NotificationType, UserAccount } from 'src/app/models';
import { TopNotificationService } from '../top-notification/top-notification.service';
import { Helpers } from 'src/app/helpers';
import { CommunicationService } from 'src/app/services/communication.service';
import { Guid } from 'guid-typescript';
import { Breakpoints } from '@angular/cdk/layout';
import { skip } from 'rxjs';

@Component({
    selector: 'medpt-epa-bulk-signature',
    templateUrl: './epa-bulk-signature.component.html',
    styleUrls: ['./epa-bulk-signature.component.scss'],
    standalone: false
})
export class EpaBulkSignatureComponent implements OnInit {
  esignform: FormGroup;
  cdnEndPoint: any = environment.cdnEndPoint;
  submitted: boolean = false;
  private currentUser: UserAccount;
  fullName: string = '';
  userName: string = '';
  documentType: string = "";
  documentTypeHeader: string = "";
  @Input() Assets: Array<any> = [];
  @Input() DocumentType!: DocumentType;
  @Input() selectedTypeId: number | null = null;
  @Output() updateBulkSignatureEvent: EventEmitter<any> = new EventEmitter();
  HasMultiplePortalAssignments: boolean = false;
  allDocumentSelected: boolean = true;
  portalInfo: IPortalConfig;
  warningMsg: string = "";
  isExternalLogin:boolean =false;
  displaytxt = '';
  selectedtxt= '';
  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private securityService: SecurityService,
    private notificationService: TopNotificationService,
    private loaderService: LoaderService,
    private documentService: DocumentService,
    private communicationService: CommunicationService,
    private userService: UserService,
    private portalService: PortalService
  ) {
    this.currentUser = this.securityService.currentUserValue;
    this.isExternalLogin = this.currentUser.Idp === "local" ? false : true; 
    this.fullName = Helpers.decodeEntity(this.currentUser.FirstName + ' ' + this.currentUser.LastName);
    this.userName = Helpers.decodeEntity(this.currentUser.UserName);
    this.esignform = this.formBuilder.group({
      password: ['', Validators.required],
      documents: this.formBuilder.array([], [Validators.required])
    });
    this.portalInfo = this.portalService.portalConfiguation?.value;
  }

  ngOnInit(): void {
this.displaytxt = this.DocumentType == DocumentType.SafetyReport ? "My electronic signature is to acknowledge my review of selected safety reports" :
"I attest that I have viewed each of the selected " + this.documentType;
this.selectedtxt = this.DocumentType == DocumentType.SafetyReport ? "Safety Report(s) " : this.documentType;
    this.documentType = this.DocumentType == DocumentType.Document ? "document" :
      this.DocumentType == DocumentType.SafetyReport ? "Safety Report(s)" : "";

    this.documentTypeHeader = this.DocumentType == DocumentType.Training ? 'Trainings' :
      this.DocumentType == DocumentType.Document ? "Documents" :
        this.DocumentType == DocumentType.SafetyReport ? "Safety Reports" : "";
    this.HasMultiplePortalAssignments = this.Assets.filter(x => x.HasMultipleAssignment == true).length > 0? true : false;
    this.warningMsg = this.DocumentType == DocumentType.Training ?
      "One or more of these trainings have been assigned to you in other studies. Upon signature, they will be marked as completed across all studies." :
      this.DocumentType == DocumentType.Document ?
        "One or more of these documents have been assigned to you in other studies. Upon signature, they will be marked as completed across all studies." :
        this.DocumentType == DocumentType.SafetyReport ?
        "One or more of these reports have been assigned to you in other studies. Upon signature, they will be marked as completed across all studies.": '';

    const checkArray: FormArray = this.esignform.get('documents') as FormArray;
    this.Assets.forEach(asset => {
      asset.checked = true;
      checkArray.push(new FormControl(this.DocumentType == DocumentType.SafetyReport ? asset.AssetID : asset.PersonAssetGUID, [Validators.required]));
    });
  }

  checkUncheckAll($event: any) {
    const checkArray: FormArray = <FormArray>this.esignform.get('documents');
    checkArray.clear();
    checkArray.controls = [];
    checkArray.removeAt(0);
    const selectAllChecked: boolean = $event.currentTarget.checked;
    this.Assets.forEach((asset: any, index: number) => {
      this.HasMultiplePortalAssignments = selectAllChecked == true && asset.HasMultipleAssignment == true ? true : false;
      asset.checked = selectAllChecked;
      if (selectAllChecked)
        checkArray.push(new FormControl(this.DocumentType == DocumentType.SafetyReport ? asset.AssetID : asset.PersonAssetGUID, [Validators.required]));
    });
    this.allDocumentSelected = checkArray.value.length == this.Assets.length;
  }

  onCheckboxChange(e: any, item: any) {
    const checkArray: FormArray = <FormArray>this.esignform.get('documents');
    item.checked = e.target.checked;
   let multiplestudies = this.Assets.filter(x => x.HasMultipleAssignment == true ) ;
    if(multiplestudies != undefined && multiplestudies.length> 0)
   {
  if( multiplestudies.find(x=>x.AssetID == item.AssetID) != undefined && multiplestudies.find(x=>x.AssetID == item.AssetID).length > 0 && multiplestudies.length == multiplestudies.find(x=>x.AssetID == item.AssetID).length)
  {
    this.HasMultiplePortalAssignments = item.checked ? true : false ;
  }
  else  if( multiplestudies.find(x=>x.AssetID == item.AssetID) != undefined && multiplestudies.find(x=>x.AssetID == item.AssetID).length ==0){
   skip;
  }
  else if(multiplestudies.find(x=>x.AssetID == item.AssetID)){
    this.HasMultiplePortalAssignments = item.checked ? true : this.Assets.filter(x=> x.checked == true && x.HasMultipleAssignment == true).length > 0? true : false ;
  }
}
     if (e.target.checked) {
      if (isNaN(e.target.value))
        checkArray.push(new FormControl(e.target.value, [Validators.required]));
      else
        checkArray.push(new FormControl(parseInt(e.target.value), [Validators.required]));
    } else {
       let index = -1;
      if (isNaN(e.target.value))
        index = (<Array<string>>checkArray.value).findIndex(asset => asset === e.target.value);
      else
        index = (<Array<number>>checkArray.value).findIndex(asset => asset === parseInt(e.target.value));
      checkArray.removeAt(index);
    }
    this.allDocumentSelected = checkArray.value.length == this.Assets.length;
  }

  onSubmitEpaSign() {
    this.submitted = true;
    if (this.esignform.valid) {
      this.loaderService.showLoader();
      let postdata = { UserName: this.currentUser.UserName, Password: this.esignform.get("password")?.value, MedPointPlatformId: Helpers.getPlatformId() };

      this.userService.AuthenticateSigningUser(postdata).then((response: IdentityUserAccount) => {
        if (response.Success) {
          let promiseData: Promise<any> = new Promise(() => { });
          if (this.DocumentType == DocumentType.SafetyReport) {
            promiseData = this.communicationService.postBulkSignature(this.esignform.get("documents")?.value);
          }
          else if (this.DocumentType == DocumentType.Document) {
            promiseData = this.documentService.PostBulkSignature(<string>this.portalInfo.SponsorName, <number>this.portalInfo.PortalID, this.esignform.get("documents")?.value);
          }
          promiseData
            .then((signresult: IESignResponse) => {
              if (signresult.Success) {
                this.notificationService.showNotification("Electronic Signature successfully completed.", NotificationType.Success);
                const dataToCallBack = { Success: true, Data: this.esignform.get("documents")?.value };
                this.updateBulkSignatureEvent.next(dataToCallBack);
                this.modal.close(true);
              } 
              else {
                this.notificationService.showNotification("An error occured during Batch Sign.", NotificationType.Error);
              }
            }).finally(() => {
              this.loaderService.hideLoader();
            });

        } else {
          this.loaderService.hideLoader();
          this.notificationService.showNotification(response.Message == "User not found." ? "Invalid username or password." : response.Message, NotificationType.Error);
        }

      }, (error: any) => {
        this.notificationService.showNotification(error.error.Message, NotificationType.Error);
        this.loaderService.hideLoader();
      }).finally(() => {

      });
    }
  }
  onSignClick(){
    this.submitted = true;
    if (this.esignform.get("documents")?.value.length > 0) {
        this.loaderService.showLoader();
      var signingId = "signingId_" + Guid.create().toString();
        const signingData = {'selectedAssetIds':this.esignform.get("documents")?.value, 'selectedTypeId':this.selectedTypeId} 
      localStorage.setItem(signingId, JSON.stringify(signingData));
        var queryString = "?signingid="+ signingId+"$"+undefined+"$"+false;
        var returnUrl = window.location.href + queryString;
        var externalUrl = environment.SSO.secureAppUrl + "/Account/ExternalLogin?provider="+this.currentUser.Idp +"&returnUrl=" + returnUrl;
        window.location.href = externalUrl;
     }
  }

}
